import React from 'react'
import { withRouter } from 'react-router-dom'

class ScrollTop extends React.Component<any, any> {
  public componentDidUpdate(prevProps: any) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
  }
  public render() {
    return this.props.children
  }
}
export default withRouter(ScrollTop)
